const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/Forms/utils/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        notANumber: 'Wert muss eine Zahl sein',
        notAnInt: 'Wert darf keine Kommastellen haben',
        mustBeAtLeast: 'Wert muss mindestens {min} sein',
        mustBeLeqThan: 'Wert darf höchstens {max} sein',
        emptyNotAllowed: 'Bitte geben Sie einen Wert an',
        passAtLeastOnTel: 'Bitte geben Sie mindenstens eine Telefonnummer an',
        emptyNotAllowedList: 'Bitte eine Auswahl treffen ',
        emptyNotAllowedRadio: 'Bitte ein Kästchen ankreuzen',
        plzInvalidNotAllowed: 'ungültig',
        phoneNumberInvalid: 'Bitte geben Sie eine gültige Nummer ein',
        emailInvalid: 'Bitte geben Sie eine gültige Email ein',
        ahvInvalid: 'Bitte geben Sie eine gültige AHV-Nr. ein',
        ahvInvalidNoDots: 'Bitte tragen Sie eine gültige AHV-Nummer ein. Das Format sollte 756xxxxxxxxxx sein.',
        lihoNotNull: 'Das Feld darf nicht leer sein',
        lihoTooLong: 'Die Eingabe ist zu lang',
        lihoCommentInvalid: 'Der Kommentar darf kein "/" enthalten',
        lihoInsuranceNumberLength: 'Die Versicherungsnummer muss exakt 20 Zeichenlang sein.',
        lihoInsuranceNumberStart: 'Die Versicherungsnummer startet immer mit "80".',
        lihoInsuranceNumberIsNotNumerical: 'Die Versicherungsnummer muss aus Nummern bestehen.',
    },
    __RELATIVE_SOURCE_FILE__
);
